import { HpEditIcon } from "@/themes/hp-client/icons/HpEditIcon";
import { useTheme } from "@/contexts/theme";

const EditingIcon = (props: any) => {
  const color = props.color || "#8283BE";
  const { currentTheme } = useTheme();
  if (currentTheme === "hp-client") {
    return (
      <HpEditIcon
        color={props?.color ?? "#1A1A1A"}
        width={props?.width ?? 24}
        height={props?.height ?? 24}
      />
    );
  }
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.33203 1.33334H5.9987C2.66536 1.33334 1.33203 2.66668 1.33203 6.00001V10C1.33203 13.3333 2.66536 14.6667 5.9987 14.6667H9.9987C13.332 14.6667 14.6654 13.3333 14.6654 10V8.66668"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6933 2.01332L5.43992 7.26665C5.23992 7.46665 5.03992 7.85999 4.99992 8.14665L4.71325 10.1533C4.60659 10.88 5.11992 11.3867 5.84659 11.2867L7.85325 11C8.13325 10.96 8.52659 10.76 8.73325 10.56L13.9866 5.30665C14.8933 4.39999 15.3199 3.34665 13.9866 2.01332C12.6533 0.679985 11.5999 1.10665 10.6933 2.01332Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.94141 2.76666C10.3881 4.36 11.6347 5.60666 13.2347 6.06"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export { EditingIcon };
